import { render } from "./OrdersTableCard.vue?vue&type=template&id=23e12052&scoped=true"
import script from "./OrdersTableCard.vue?vue&type=script&lang=js"
export * from "./OrdersTableCard.vue?vue&type=script&lang=js"

import "./OrdersTableCard.vue?vue&type=style&index=0&id=23e12052&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e12052"]])

export default __exports__